"use script";

angular.module("vendor")
.constant("QUICKBOOKS", {
    "INTEGRATION_GUIDE_URL": {
        "fr": "https://wego.trade/fr/comment-integrer-quickbooks-online/",
        "en": "https://wego.trade/how-to-integrate-quickbooks-online/",
        "es": "https://wego.trade/how-to-integrate-quickbooks-online/"
    }
});



//////////////////
// WEBPACK FOOTER
// ./vendor/app-core/quickbooks/quickbooks.constant.js
// module id = 865
// module chunks = 0